import { NavLink } from 'react-router-dom';
import type { AppModule } from './module';
import { Icon } from './Icon';

/** 하단 고정 탭바. showInBottomNav 모듈 + "더보기" 버튼. 터치 타깃 ≥44px. */
export function BottomNav({
  items,
  hasMore,
  onMore,
}: {
  items: AppModule[];
  hasMore: boolean;
  onMore: () => void;
}) {
  return (
    <nav className="shrink-0 border-t border-line bg-card pb-safe">
      <div className="mx-auto flex max-w-md items-stretch justify-around px-1">
        {items.map((m) => (
          <NavLink
            key={m.id}
            to={m.route}
            end={m.route === '/'}
            className={({ isActive }) =>
              `flex min-h-[56px] min-w-[56px] flex-1 flex-col items-center justify-center gap-1 rounded-2xl py-1.5 text-[11px] tap-bounce ${
                isActive ? 'text-accentA' : 'text-ink-soft'
              }`
            }
          >
            <Icon name={m.icon} size={22} strokeWidth={2.2} />
            <span>{m.title}</span>
          </NavLink>
        ))}
        {hasMore && (
          <button
            type="button"
            onClick={onMore}
            className="flex min-h-[56px] min-w-[56px] flex-1 flex-col items-center justify-center gap-1 rounded-2xl py-1.5 text-[11px] text-ink-soft tap-bounce"
          >
            <Icon name="MoreHorizontal" size={22} strokeWidth={2.2} />
            <span>더보기</span>
          </button>
        )}
      </div>
    </nav>
  );
}
